import { render, staticRenderFns } from "./additional-info.vue?vue&type=template&id=76a080c0&scoped=true"
import script from "./additional-info.vue?vue&type=script&lang=js"
export * from "./additional-info.vue?vue&type=script&lang=js"
import style0 from "./additional-info.vue?vue&type=style&index=0&id=76a080c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a080c0",
  null
  
)

export default component.exports